/* This example requires Tailwind CSS v2.0+ */
import React, { Fragment } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import {
  BellIcon,
  MenuIcon,
  XIcon,
  SunIcon,
  MoonIcon,
  SearchIcon,
  PlusIcon,
  ChevronLeftIcon,
  UserCircleIcon,
} from "@heroicons/react/outline";
import useDarkMode from "../../configs/dark-mode/useDarkMode";
import { connect } from "react-redux";
import { changeTheme } from "../../redux/darkmode/darkmode.actions";
import { Link, useLocation } from "react-router-dom";
import iconLight from "../../assests/img/logo-for-light.png";

const navigation = [
  { name: "Beranda - Bursa", to: "/", current: true },
  { name: "Daftar Kuisioner", to: "/daftar-kuesioner", current: false },
  { name: "Partisipasi", to: "/partisipasi", current: false },
  { name: "Responden", to: "/responden", current: false },
  { name: "Hasil Kuis", to: "/hasil-kuis", current: false },
  // { name: "History Scoin", to: "/history-scoin", current: false },
];


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Navbar(props) {
  const [colorTheme, setTheme] = useDarkMode();
  let location = useLocation();
  const userData = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};

  
  return (
    <>
      <Disclosure
        as="nav"
        style={{ zIndex: "99", minWidth: "1280px" }}
        className={`bg-primary fixed w-full`}
      >
        {({ open }) => (
          <>
            <div className="mx-auto px-2 sm:px-6 lg:px-8">
              <div className="relative flex items-center justify-between h-16">
                <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                  {/* Mobile menu button*/}
                  <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
                <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                  <div className="flex-shrink-0 flex items-center">
                    {colorTheme !== "light" ? (
                      <>
                        <img
                          className="block lg:hidden h-8 w-auto"
                          src={iconLight}
                          alt="Workflow"
                        />
                        <img
                          className="hidden lg:block h-8 w-auto"
                          src={iconLight}
                          alt="Workflow"
                        />
                      </>
                    ) : (
                      <>
                        <img
                          className="block lg:hidden h-8 w-auto"
                          src={iconLight}
                          alt="Workflow"
                        />
                        <img
                          className="hidden lg:block h-8 w-auto"
                          src={iconLight}
                          alt="Workflow"
                        />
                      </>
                    )}
                  </div>
                  <div className="hidden sm:block sm:ml-6">
                    <div className="flex space-x-4"></div>
                  </div>
                </div>
                <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                  {/* <div className="flex flex-row p-1 bg-gray-200 dark:bg-gray-600 rounded-lg mx-10 items-center">
                    <SearchIcon className="w-4 h-4 mx-2 text-gray-400 dark:text-gray-100" />
                    <input
                      type="text"
                      placeholder="Cari disini"
                      className="bg-gray-200 text-gray-600 dark:bg-gray-600"
                    />
                  </div> */}
                  <div
                    className="flex flex-row justify-between border border-gray-400 rounded-full p-1 mr-2 cursor-pointer"
                    onClick={() => {
                      setTheme(colorTheme);
                      props.changeTheme();
                    }}
                  >
                    <button
                      className={
                        colorTheme !== "light"
                          ? "mr-2 bg-blue-200 text-blue-700 rounded-full p-1"
                          : "mr-2 p-1 text-white"
                      }
                    >
                      <SunIcon className="h-4 w-4" />
                    </button>
                    <button
                      className={
                        colorTheme === "light"
                          ? "ml-2 bg-blue-200 text-blue-700 rounded-full p-1"
                          : "ml-2 p-1 text-white"
                      }
                    >
                      <MoonIcon className="h-4 w-4" />
                    </button>
                  </div>
                  {/* <button
                    type="button"
                    className=" p-2 border border-gray-400 rounded-full text-gray-700 dark:text-white hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                  >
                    <span className="sr-only">View notifications</span>
                    <BellIcon className="h-4 w-4" aria-hidden="true" />
                  </button> */}

                  {/* Profile dropdown */}
                  <Menu as="div" className="ml-3 relative">
                    <div>
                      <Menu.Button className="flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                        <span className="sr-only">Open user menu</span>
                        {userData.foto_profil ? (
                          <button
                            type="button"
                            class="flex mr-3 text-sm bg-gray-800 rounded-full md:mr-0 focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
                            id="user-menu-button"
                            aria-expanded="false"
                            type="button"
                            data-dropdown-toggle="dropdown"
                          >
                            <span class="sr-only">Open user menu</span>
                            <img
                              class="w-8 h-8 rounded-full"
                              src={`https://static.schoolmedia.id/public/assets/socmed/${userData.group_code}/photo/${userData.foto_profil}`}
                              alt="user photo"
                            />
                          </button>
                        ) : (
                          <UserCircleIcon className="h-8 w-8 text-white" />
                        )}
                      </Menu.Button>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items
                        className={`origin-top-right bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-500 absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 focus:outline-none`}
                      >
                        <Menu.Item>
                          <div className="flex text-gray-800 dark:text-white flex-col p-4 m-2 rounded border">
                            <p className="text-lg font-bold">
                              {userData?.name}
                            </p>
                            <p className="text-xs">{userData?.email}</p>
                          </div>
                        </Menu.Item>
                        {navigation.map((val, idx) => {
                          return (
                            <Menu.Item key={idx}>
                              {({ active }) => (
                                <Link
                                  to={val.to}
                                  className={classNames(
                                    active ? "" : "",
                                    "block px-4 py-2 text-sm text-gray-700 dark:text-white"
                                  )}
                                >
                                  {val.name}
                                </Link>
                              )}
                            </Menu.Item>
                          );
                        })}
                        <Menu.Item>
                          {({ active }) => (
                            <Link to="/auth/sso/logout">
                              <p
                                className={classNames(
                                  active ? "bg-gray-100" : "",
                                  "block px-4 py-2 text-sm text-gray-700"
                                )}
                              >
                                Sign out
                              </p>
                            </Link>
                          )}
                        </Menu.Item>
                      </Menu.Items>
                    </Transition>
                  </Menu>

                  {location.pathname === "/buat" ? (
                    <button
                      onClick={() => window.history.back()}
                      className="px-4 py-2 flex flex-row items-center ml-10 rounded-lg bg-blue-500 text-white shadow-xl hover:shadow-2xl"
                    >
                      <ChevronLeftIcon className="h-4 w-4 mr-2" />
                      <p className="text-sm">Kembali</p>
                    </button>
                  ) : (
                    <Link to="/buat">
                      <button className="px-4 py-2 flex flex-row items-center ml-10 rounded-lg bg-blue-500 text-white shadow-xl hover:shadow-2xl">
                        <PlusIcon className="h-4 w-4 mr-2" />
                        <p className="text-sm">Buat Kuis</p>
                      </button>
                    </Link>
                  )}
                </div>
              </div>
            </div>

            <Disclosure.Panel className="sm:hidden">
              <div className="px-2 pt-2 pb-3 space-y-1"></div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
      <Disclosure
        as="nav"
        style={{ zIndex: "99", minWidth: "1280px" }}
        className={`${
          colorTheme !== "light" ? "bg-blur-light" : "bg-blur-dark"
        } border-b border-gray-300 dark:border-gray-600 fixed w-full`}
      >

      </Disclosure>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    themes: state.darkmode.theme,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeTheme: () => dispatch(changeTheme()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
